import { Injectable, inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { CustomValidatorFns } from '../_shared/models/custom-validator-functions.model';
import { IFormElementBaseConfig } from '../_shared/models/form/form-element-base.model';
import { FormSubmissionData } from '../_shared/models/form/form-submission-data.model';
import { LegalConsentOptions } from '../_shared/models/form/legal-consent/legal-consent-options.model';

@Injectable({
    providedIn: 'root',
})
export class FormService {
    private _fb = inject(FormBuilder);

    isSubmitting = new BehaviorSubject<boolean>(false);

    createForm(elements: IFormElementBaseConfig[]) {
        const form: FormGroup = this._fb.group({});

        elements.forEach((x: IFormElementBaseConfig) => {
            x.form = form;

            form.addControl(x.name, this.createControl(x.value, x.validation));
        });

        return form;
    }

    createControl(value: string | boolean, validators: string[] = []) {
        return this._fb.control(
            { value: value, disabled: false },
            {
                nonNullable: true,
                validators: this.createValidators(validators),
            }
        );
    }

    createValidators(validation: string[]): ValidatorFn[] {
        const validationKeys: string[] = validation.filter(
            (key: string) => key in CustomValidatorFns
        );

        const validators: ValidatorFn[] = validationKeys.map(
            (key: string) => CustomValidatorFns[key]
        );

        return validators;
    }

    createFormSubmissionData(
        data: { [key: string]: string },
        consent?: LegalConsentOptions
    ): FormSubmissionData {
        const csntOpts = consent ?? new LegalConsentOptions();

        return {
            fields: data,
            LegalConsentOptions: csntOpts,
        };
    }

    validateForm(form: FormGroup): void {
        Object.keys(form.controls).forEach((key) => {
            const control: AbstractControl | null = form.get(key);
            control?.markAsTouched({ onlySelf: true });
            control?.updateValueAndValidity();
        });
    }

    getFormCategory(formName: string): string {
        if (formName.indexOf('-') === -1 || formName.split('-')[1].trim() === '') return 'other';

        return formName.split('-')[1].trim();
    }
}
